import { IconContainer, ToggleCircle, ToggleContainer } from "./styles";

import { FC } from "react";
import Icon from "../Icon";
import { Theme } from "../../styles";
import { ToggleProps } from "./types";
import { useTheme } from "styled-components";

const Toggle: FC<ToggleProps> = ({ toggleTheme }) => {
  const theme = useTheme() as Theme;

  return (
    <ToggleContainer onClick={toggleTheme}>
      <ToggleCircle />
      <IconContainer>
        {theme.mode === "light" ? (
          <Icon iconName="sun" height="16" width="16" />
        ) : (
          <Icon iconName="moon" height="16" width="16" />
        )}
      </IconContainer>
    </ToggleContainer>
  );
};

export default Toggle;
